<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 設問セットの説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

  <mat-card appearance="outlined" class="manual-card">
    <mat-card-header>
      <mat-card-title><span>設問セットの説明</span></mat-card-title>
    </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/quest-set.png" width="100%">
        </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/A.png"> 追加ボタン
      </div>
      <div class="manual-explain">
        クリックすることで追加画面が表示されます。
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/B.png"> 削除ボタン
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/C.png"> Filter
      </div>
      <div class="manual-explain">
        設問セット一覧に表示されているデータのフィルタリングを行います。<br>
        ※フィルタリングの対象は、表示タイトル、管理名称
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/D.png"> 設問セット一覧
      </div>
      <div class="manual-explain">
        登録済みの設問セットの一覧が表示されます。<br>
        表示中チェックのある設問セットがユーザー画面のアンケートに表示されます。<br>
        （表示中チェックは追加／編集画面で設定することができます。）<br>
        編集アイコンをクリックすることで編集画面が表示されます。
      </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Question Sets
  </div>
  
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
  
    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Question Sets</span></mat-card-title>
      </mat-card-header>
  
      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_quest-set.png" width="100%">
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Add Button
        </div>
        <div class="manual-explain">
          Clicking this button will display the add screen.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Delete Button
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Filter
        </div>
        <div class="manual-explain">
          Filters the data displayed in the question set list.<br>
          *Filter targets: Display Title, Management Name
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Question Set List
        </div>
        <div class="manual-explain">
          Displays a list of registered question sets.<br>
          Question sets with the "Displayed" check will appear in the user survey screen.<br>
          (The "Displayed" check can be set in the add/edit screen.)<br>
          Clicking the edit icon will display the edit screen.
        </div>
  
      </mat-card-content>
    </mat-card>
  
  </div>  
</div>